/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
 */
let MainLayoutCoach = () => import(/* webpackChunkName: "RecoveryWorkspace" */  "@/core/recoveryCoachingApp/components/Layouts/MainLayoutCoach.vue");
import clientsRoutes from "@/router/recoveryCoaching/clients/clientsRoutes.js";
import dashboardRoutes from "@/router/recoveryCoaching/dashboardRoutes.js";
import resourcesRoutes from "@/router/resources/resourcesRoutes.js";
import coachingPackagesRoutes from "@/router/recoveryCoaching/coachingPackages/coachingPackagesRoutes.js";
import schedulerRoutes from "@/router/scheduler/schedulerRoutes.js";
import profileRoutes from "@/router/profileRoutes.js";
import portalRoutes from "@/router/recoveryCoaching/portal/portalRoutes.js";
import teamRoutes from "@/router/recoveryCoaching/team/teamRoutes.js";

import mergeProps from "@/router/utils/mergeProps.js";

import billingRoutes from "@/router/billingRoutes";
import redirectByName from "@/router/utils/redirectByName.js";


export default [


	{
		path: '/recovery',
		name: 'CoachMain',
		component: MainLayoutCoach,
		redirect:{name: 'DashboardMainRoute'},
		meta:{
			coachAuth:true
		},
		children: [
			...clientsRoutes,
			...dashboardRoutes,
			// ...workflowRoutes,
			...resourcesRoutes,
			...schedulerRoutes("Recovery"),
			...billingRoutes,
			...coachingPackagesRoutes,
			...profileRoutes(""),
			...teamRoutes,


			// {
			// 	path: 'clients',
			// 	name: 'ClientsListRoute',
			// 	component: EmptyRouterView,
			// },
			{
				path: ':catchAll(.*)*',
				redirect: {name: 'CoachMain'}
			},

		]
	},

	...portalRoutes,
]

